import { connect } from "react-redux";
import Component from "./DeleteUser";

export default connect(
    null,
    ({ scp: { deleteUser }, alert: { silence }, auth: { loggedIn, user} }) => ({ deleteUser ,silence, loggedIn, user }), 
)(Component);
